import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-time-picker', {
    mixins: [FormElementMixin],
    data() {
        return {
            timepicker: false,
            pickedTime: null
        }
    },
    methods: {
        prependClicked() {
            this.timepicker = true;
        }
    },
    watch: {
        pickedTime: {
            handler(val) {
                console.log(val);
                this.currentValue = val;
            }
        }
    }
}, 'form/controls/ak-time-picker.html');